import styled from 'styled-components'
import { Button, tokens } from '@arvoreeducacao/bonsai-ds'
import OriginalModal from 'components/lib/modals/Modal'
import type { ModalProps } from './Modal.types'

export const Modal = styled(OriginalModal)<ModalProps>`
  width: 95%;
  height: fit-content;
  border-radius: ${tokens.radius.large};

  @media (min-width: ${tokens.sizes.mdScreen}px) {
    width: 500px;
  }
`

export const Title = styled.div`
  text-align: left;
  color: ${tokens.colors.black6};
  font-weight: bold;
  font-size: ${tokens.sizes.h[4].tablet};
  line-height: 30px;
`

export const Description = styled.div`
  text-align: left;
  font-weight: normal;
  font-size: ${tokens.sizes.text}px;
  line-height: 28px;
  color: ${tokens.colors.black4};
  margin: 16px 0;
`

export const ButtonContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`

export const StyledButton = styled(Button)``
